
import { createRoot } from 'react-dom/client'
import App from './App.tsx'
import './index.css'
import { ErrorBoundary } from './components/ErrorBoundary.tsx'

const initializeApp = () => {
  const rootElement = document.getElementById("root");
  
  if (!rootElement) {
    console.error('Root element not found');
    return;
  }

  try {
    const root = createRoot(rootElement);
    
    root.render(
      <ErrorBoundary>
        <App />
      </ErrorBoundary>
    );
  } catch (error) {
    console.error('Failed to initialize app:', error);
    
    rootElement.innerHTML = `
      <div style="display: flex; align-items: center; justify-content: center; height: 100vh; font-family: system-ui; background: #f8f9fa;">
        <div style="text-align: center; padding: 40px; background: white; border-radius: 8px; box-shadow: 0 2px 10px rgba(0,0,0,0.1); max-width: 400px;">
          <h1 style="color: #dc3545; margin-bottom: 16px;">App Loading Error</h1>
          <p style="color: #6c757d; margin-bottom: 24px; line-height: 1.5;">
            There was an issue loading the application. This might be a temporary problem.
          </p>
          <button onclick="window.location.reload()" 
                  style="background: #007bff; color: white; border: none; padding: 12px 24px; border-radius: 4px; cursor: pointer; font-size: 16px; margin-right: 8px;">
            Refresh Page
          </button>
          <button onclick="window.location.href = window.location.origin" 
                  style="background: #6c757d; color: white; border: none; padding: 12px 24px; border-radius: 4px; cursor: pointer; font-size: 16px;">
            Go Home
          </button>
          <details style="margin-top: 16px; text-align: left;">
            <summary style="cursor: pointer; color: #6c757d;">Error Details</summary>
            <pre style="background: #f8f9fa; padding: 8px; border-radius: 4px; overflow: auto; font-size: 12px; margin-top: 8px;">${error.toString()}</pre>
          </details>
        </div>
      </div>
    `;
  }
};

const safeInitialize = () => {
  try {
    if (typeof createRoot === 'undefined') {
      throw new Error('React createRoot is not available');
    }
    initializeApp();
  } catch (error) {
    console.error('Critical initialization error:', error);
    
    const rootElement = document.getElementById("root");
    if (rootElement) {
      rootElement.innerHTML = `
        <div style="display: flex; align-items: center; justify-content: center; height: 100vh; font-family: system-ui;">
          <div style="text-align: center;">
            <h1>Critical Error</h1>
            <p>The application failed to start. Please refresh the page or contact support.</p>
            <button onclick="window.location.reload()" style="padding: 8px 16px; margin-top: 8px;">Refresh</button>
          </div>
        </div>
      `;
    }
  }
};

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', safeInitialize);
} else {
  setTimeout(safeInitialize, 10);
}
